// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1TOgX","alert":"SettungsInbox_alert__Iu7me"};